<template>
  <white-bg padding="25px 30px" :class="{need}">
    <div class="settings__top">
      <h3>Смена пароля</h3>
      <input style="height: 0; padding: 0; margin: 0; border: none; width: 0; position: absolute"/>
      <input style="height: 0; padding: 0; margin: 0; border: none; width: 0; position: absolute" type="password"/>
      <div style="margin-bottom: 20px;">
        <div class="settings-input">
          <div class="params">Новый пароль</div>
          <input :type="input.password" v-model="form.password" @change="errors.password = null">
          <button @click="changeInput('password')" :class="input.password"></button>
        </div>
        <error-text :text="errors.password"/>
      </div>
      <div style="margin-bottom: 20px;">
        <div class="settings-input">
          <div class="params">Подтвердите пароль</div>
          <input :type="input.password_confirmation" v-model="form.password_confirmation" @change="errors.password_confirmation = null">
          <button @click="changeInput('password_confirmation')" :class="input.password_confirmation"></button>
        </div>
        <error-text :text="errors.password_confirmation"/>
      </div>
      <button-component :loading="loading" variant="filled" @click="update">Изменить</button-component>
    </div>
  </white-bg>
</template>

<script>
import ButtonComponent from "@/components/ui/buttons/button-component";
import WhiteBg from '../../../../components/ui/white-bg'
import ErrorText from '../../../../components/ui/text/error-text';
import {mapMutations, mapGetters} from 'vuex'

export default {
  name: "Password",
  components: {WhiteBg, ErrorText, ButtonComponent},
  props: {
    need: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {},
      errors: {},
      input: {
        password_confirmation: 'password',
        password: 'password',
      },
    }
  },
  computed: mapGetters(['getUser']),
  methods: {
    ...mapMutations(['setUser']),
    changeInput(type) {
      this.input[type] = this.input[type] === 'password' ? 'text' : 'password';
    },
    update() {
      this.loading = true;
      return this.$api.master.password(this.form)
        .then(() => {
          this.form = {};
          this.errors = {};
          this.input = {
            password_confirmation: 'password',
            password: 'password',
          };
          if (this.need) {
            this.setUser({...this.getUser, need_change_password: 0})
          }
          this.$toast.success('Сохранено!');
        })
        .catch(({response}) => this.errors = response.data.errors)
        .finally(() => this.loading = false);
    }
  },
}
</script>

<style scoped lang="scss">
h3 {
  padding-bottom: 0;
}

.need {
  position: relative;
  z-index: 301;
  animation: pulse 0.8s ease-out infinite;
}

@keyframes pulse {
  50% {
    box-shadow: 0 0 0 1em rgba(255, 255, 255, 0.3);
  }
  100% {
    box-shadow: 0 0 0 2em rgba(255, 255, 255, 0);
  }
}

.settings {
  padding: 30px 30px 0 30px;

  &__top {
    h3 {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #383838;
      padding-bottom: 20px;
    }
  }

  &__bottom {
    padding: 30px -15px 0 0;
    border-top: 1px solid #E5E5E5;
    display: flex;

    &-prices {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .close {
        height: 50px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      h3 {
        padding-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      button {
        margin-top: 0;
        width: auto;
        font-weight: 600;
        font-size: 16px;
        line-height: 1.4;
        color: #B9765B;
        background-color: transparent;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 0;

        &:before {
          content: '';
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-image: url("../../../../assets/images/icons/edit.svg");
          background-position: center center;
          background-size: contain;
        }
      }
    }
  }

  &__services {
    padding-bottom: 10px;

    h3 {
      padding-top: 15px;
    }

    button {
      visibility: visible;
      height: 20px;
      margin-top: 0;
      width: auto;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      color: #B9765B;
      background-color: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 10px 0 25px 0;

      &:before {
        content: '';
        width: 20px;
        height: 20px;
        margin-right: 5px;
        background-image: url("../../../../assets/images/icons/edit.svg");
        background-position: center center;
        background-size: contain;
      }
    }
  }
}

.select {
  height: 37.5px;
  width: 100%;
  max-width: unset;
  margin-bottom: 20px;
}

button {
  width: 100%;
  height: 50px;
  border: none;
  background: #DBBFA7;
  border-radius: 5px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #383838;
  margin-top: 15px;
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  .camera {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;

    &:hover .camera-visible {
      visibility: visible;
    }

    .camera-visible {
      visibility: hidden;
      position: absolute;
      background: rgba(56, 56, 56, 0.70);
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      img {
        width: 37.95px;
        height: 30.8px;
        border-radius: unset;
      }
    }
  }

  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
  }
}

h3 {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
  padding-bottom: 0;
}

.params {
  padding-left: 10px;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #808080;
  font-family: "Open Sans", sans-serif;
}

.settings-input {
  position: relative;
  width: 100%;

  input {
    font-family: "Open Sans", sans-serif;
    width: 100%;
    height: 37.5px;
    background: #FFFFFF;
    border: 1px solid #DBBFA7;
    border-radius: 5px;
    padding-left: 20px;
    color: #383838;
    font-size: 16px;

    &::placeholder {
      font-size: 16px;
      line-height: 24px;
      color: #808080;
    }
  }

  button {
    margin-top: 10px;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: none;
    background-image: url('../../../../assets/images/icons/eye-off.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
  }

  button.text {
    background-image: url('../../../../assets/images/icons/eye.svg');
  }
}

@media screen and (max-width: 1170px) {
  .whiteBg {
    margin: 0 -15px !important;
  }
}
</style>
